'use client';

import { useEffect, useCallback } from 'react';
import { useInteractStore } from '../../store/interact-store';
import { useLayoutStore } from '../../store/layoutStore';

export function InteractSessionProvider() {
  const setActiveSession = useInteractStore((state) => state.setActiveSession);
  const setSelectedInteraction = useInteractStore(
    (state) => state.setSelectedInteraction,
  );
  const refreshInteractions = useInteractStore(
    (state) => state.refreshInteractions,
  );
  const listSessions = useInteractStore((state) => state.listSessions);
  const setSidebarTab = useLayoutStore((state) => state.setSidebarTab);
  const openMainContentTab = useLayoutStore(
    (state) => state.openMainContentTab,
  );

  const handleOpenInteractSession = useCallback(
    async (event: CustomEvent) => {
      const { domain, interactionId } = event.detail || {};
      if (!domain) return;

      await listSessions();

      const currentSessions = useInteractStore.getState().sessions;
      const session = currentSessions.find((s) => s.domain === domain);

      if (session) {
        setActiveSession(session.id);
        await refreshInteractions(session.id);
        if (
          typeof interactionId === 'string' &&
          interactionId.trim().length > 0
        ) {
          const refreshedSession = useInteractStore
            .getState()
            .sessions.find((s) => s.id === session.id);
          const matchedInteraction = refreshedSession?.interactions.find(
            (interaction) =>
              interaction.id === interactionId ||
              interaction.uniqueId === interactionId,
          );
          setSelectedInteraction(matchedInteraction?.id ?? null);
        }
      }

      setSidebarTab('interact');
      openMainContentTab({
        id: 'interact',
        title: 'Interact',
        type: 'interact',
      });
    },
    [
      listSessions,
      setActiveSession,
      setSelectedInteraction,
      refreshInteractions,
      setSidebarTab,
      openMainContentTab,
    ],
  );

  useEffect(() => {
    window.addEventListener(
      'terra-open-interact-session',
      handleOpenInteractSession as unknown as EventListener,
    );

    return () => {
      window.removeEventListener(
        'terra-open-interact-session',
        handleOpenInteractSession as unknown as EventListener,
      );
    };
  }, [handleOpenInteractSession]);

  return null;
}
